import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Button } from '@material-ui/core';
import { useFormikContext } from 'formik';

import { Label } from 'core/components/label';
import { useObserver } from 'mobx-react';
import { useStore } from 'core/store/store.mobx';
import DialogError from '../dialog-error';

const SomethingWrong = ({ errors = [], rejections = [], classes }) => {
  const { submitForm } = useFormikContext();
  const { offer: store } = useStore();
  const onClick = () => {
    submitForm();
    store.triggerOfferDialog(false);
  };

  return useObserver(() => (
    <>
      <Label type="titleSecondary" className={classes.title}>
        Something went wrong
      </Label>
      <Label type="infoInnerTitle" className={classes.content}>
        Unfortunately, we cannot offer you a price for insurance at this time.
      </Label>
      {[...errors, ...rejections].map((error, index) => (
        <DialogError key={`${error.code}-${index}`} error={error} />
      ))}
      <Grid container alignItems="center" className={classes.bottom}>
        <Button onClick={onClick} variant="contained" color="primary" className={classes.btn}>
          <Label className={classes.btnLabel}>Try again</Label>
        </Button>
      </Grid>
    </>
  ));
};

SomethingWrong.propTypes = {
  errors: PropTypes.array.isRequired,
  rejections: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired
};

export default SomethingWrong;
